/**
 * Mobil uygulamanın Google girişi sistem tarayıcısında yapılır (Custom Tab /
 * ASWebAuthenticationSession). Google jetonu https://text2.online/login#...&state=app ile
 * döndürür; burada uygulamanın adresine (text2online://oauth) aktarılır ve tarayıcı
 * penceresi kapanıp uygulama girişi tamamlar. React yüklenmeden önce çalışır.
 */
(function forwardAppOAuthResult() {
  if (typeof window === 'undefined') return;
  const { pathname, hash } = window.location;
  if (pathname !== '/login' || !hash) return;
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  if (params.get('state') !== 'app') return;
  if (!params.get('id_token') && !params.get('error')) return;
  window.location.replace(`text2online://oauth#${hash.replace(/^#/, '')}`);
}());
